import { useWeb3React } from '@web3-react/core';
import { getConstant } from 'config/chains';
import icInfo from 'img/lockMMY/info.svg'
import { useChainId } from 'lib/chains';
import { importImage } from 'lib/legacy';
const StakingLP = () => {
  const { chainId } = useChainId()
  const { account, active, library } = useWeb3React();
  const nativeTokenSymbol = getConstant(chainId, "nativeTokenSymbol");
  const nativeTokenImage = importImage(`ic_${nativeTokenSymbol?.toLowerCase()}_24.svg`);
  return (
    <div className="staking-lp-container">
      <div className="desc">
        Stake your veMMY-LP tokens to earn profit share in FTM.
      </div>
      <div className="staking-content">
        <div className="staking-card">
          <div className="staking-card-content">
            <div className="staking-title">Your available</div>
            <div className="staking-value">0 veMMY-LP</div>
          </div>
          <div className="staking-card-content">
            <div className="staking-title">Your staked</div>
            <div className="staking-value">100.05 veMMY-LP <span>(2% share)</span></div>
          </div>
          <div className="staking-card-content">
            <div className="staking-title">Your APR <img alt='' src={icInfo}/></div>
            <div className="staking-value green-value">200.88%</div>
          </div>
          <div className="action-button">
            <button className='App-button-option border-btn'>Unstake</button>
          </div>
        </div>
        <div className="staking-card">
          <div className="big-title">Your pending rewards</div>
          <div className='pending-reward-container'>
            <div className='pending-info'>
              <img alt='' src={nativeTokenImage}/>
              <div className='value'>100.05 FTM</div>
              <div className='value-dollar'>$120.86M</div>
            </div>
          </div>
          <div className='action-button'>
            <button className='App-button-option'>Claim</button>
            </div>
        </div>
      </div>

    </div>
  )
}
export default StakingLP;
